import { useEffect, useState } from "react";
import { slackMrkdwnToHtml } from "../../lib/slackMrkdwnToHtml";

type RecapPayload = {
	roomId: string;
	question: string;
	resultsPersona: string;
	recap: {
		title: string;
		bodyMrkdwn: string;
		footer: string;
	};
};

type ResultsRecapProps = {
	roomId: string;
};

export function ResultsRecap({ roomId }: ResultsRecapProps) {
	const [data, setData] = useState<RecapPayload | null>(null);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		setError(null);
		setData(null);
		let cancelled = false;
		(async () => {
			try {
				const res = await fetch(`/api/rooms/${encodeURIComponent(roomId)}/recap`);
				if (!res.ok) {
					if (!cancelled) setError("Recap is not available yet.");
					return;
				}
				const body = (await res.json()) as RecapPayload;
				if (!cancelled) setData(body);
			} catch {
				if (!cancelled) setError("Could not load recap.");
			}
		})();
		return () => {
			cancelled = true;
		};
	}, [roomId]);

	if (error) return null;
	if (!data) return null;

	return (
		<div className="mt-6 rounded-xl border border-wi-gold/25 bg-wi-surface/90 p-4">
			<p className="font-medium text-sm text-wi-text">{data.recap.title}</p>
			<div
				className="mt-2 text-sm text-wi-text/85 leading-relaxed"
				dangerouslySetInnerHTML={{ __html: slackMrkdwnToHtml(data.recap.bodyMrkdwn) }}
			/>
			<p className="mt-3 text-wi-text/55 text-xs">{data.recap.footer}</p>
		</div>
	);
}
